module.exports = __webpack_public_path__ + "img/incendio.2affdba3.svg";